"use client";

import * as React from "react";
import { cn } from "@/utils/utils";
import { styleDrivers } from "@/utils/componentStyle";

export type PageContainerSize = "sm" | "md" | "lg" | "xl" | "full";

export interface PageContainerProps
  extends React.HTMLAttributes<HTMLDivElement> {
  /** Maximum width constraint */
  size?: PageContainerSize;
  /** Center the container horizontally */
  centered?: boolean;
  /** Enable scroll behavior */
  scrollable?: boolean;
}

/**
 * PageContainer - Page-level wrapper with max-width constraints
 *
 * Responsibilities:
 * - Max-width constraint (configurable)
 * - Page-level horizontal padding
 * - Optional centered layout
 * - Scroll behavior
 */
const PageContainer = React.forwardRef<HTMLDivElement, PageContainerProps>(
  (
    {
      className,
      children,
      size = "xl",
      centered = true,
      scrollable = false,
      ...props
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={cn(
          styleDrivers.pageContainer.root,
          styleDrivers.pageContainer.sizes[size],
          centered && "mx-auto",
          scrollable && "overflow-auto",
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);

PageContainer.displayName = "PageContainer";

export { PageContainer };
